import { useEffect, useState } from "react";
import { ExternalLink, BookOpen } from "lucide-react";
import api from "../lib/api";

export default function WikiPanel({ title }) {
  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoaded(false); setData(null);
    api.get("/wiki", { params: { title } })
      .then((r) => { if (alive) { setData(r.data); setLoaded(true); } })
      .catch(() => { if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, [title]);

  if (loaded && (!data || !data.extract)) return null;

  return (
    <div className="border border-zinc-300 bg-white overflow-hidden" data-testid="wiki-panel">
      {data?.thumbnail && (
        <div className="h-56 bg-zinc-100 flex items-center justify-center overflow-hidden">
          <img src={data.thumbnail} alt={data.title} className="w-full h-full object-cover" />
        </div>
      )}
      <div className="p-5">
        <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-primary mb-2">
          <BookOpen className="w-3.5 h-3.5" /> Encyclopaedia
        </div>
        {!loaded ? (
          <div className="h-4 w-24 bg-zinc-200 animate-pulse" />
        ) : (
          <>
            <p className="text-base leading-relaxed text-zinc-800">{data.extract}</p>
            {data.url && (
              <a href={data.url} target="_blank" rel="noreferrer" data-testid="wiki-link"
                className="mt-3 inline-flex items-center gap-1 text-sm text-primary hover:underline">
                Read full article on Wikipedia <ExternalLink className="w-3.5 h-3.5" />
              </a>
            )}
          </>
        )}
      </div>
    </div>
  );
}
